import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { HelmetProvider } from 'react-helmet-async'
import { ToastProvider } from './components/ToastProvider'
import { SupabaseAuthProvider } from './components/SupabaseAuthProvider.jsx'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase configuration is missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <ToastProvider>
        <SupabaseAuthProvider>
          <App />
        </SupabaseAuthProvider>
      </ToastProvider>
    </HelmetProvider>
  </StrictMode>,
)
